import React from 'react'
import { observer } from 'mobx-react'

import { labelsStore } from 'sdc-i18n-stores'

export const BoardName = observer(({board,...props}) => <span data-id={labelsStore.lastUpdate} {...props}> {board?.name || labelsStore.labelFor('board.unnamed')} </span>)
